<template v-if="ifPresent && imgUrl">
  <div data-grm-comp="UserProfileImage" class="user-image"
       :class="{
          blank: !imgLoaded && useBlankImage
       }"
  >
    <img class="user-img"
         v-if="imgUrl && imgLoaded" :src="imgUrl" :alt="$t('common.user')"
         @load="emitLoadedEvent"
         @error="emitImageNotFoundEvent"
    >
  </div>
<!--  <div v-else class="user-image none"></div>-->
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "UserProfileImage",
  props: {
    userId: {
      type: String,
      default: null
    },
    ifPresent: {
      type: Boolean,
      default: false
    },
    useBlankImage: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      imgLoaded: false,
      imgUrl: '',
    }
  },
  watch:{
    userProfileImageUrl(newImageUrl) {
      if (!newImageUrl) {
        this.$nextTick(() => {
          this.emitImageNotFoundEvent();
        });
      }
      this.imgUrl = newImageUrl;
      this.imgLoaded = !!newImageUrl;
    },
  },
  computed: {
    ...mapGetters('camstudy', ['userProfileImage']),
    userProfileImageUrl() {
      if (!this.userId) {
        this.$nextTick(() => {
          this.emitImageNotFoundEvent();
        });
        return '';
      }
      let url = this.userProfileImage(this.userId);
      return url;
    }
  },
  mounted() {
    this.imgUrl = this.userProfileImageUrl;
    if(this.imgUrl){
      this.imgLoaded = true;
    }
  },
  methods: {
    emitLoadedEvent () {
      this.$emit('imageLoaded');
    },
    emitImageNotFoundEvent () {
      this.$emit('imageNotFound');
    }
  }
}
</script>

<style scoped lang="scss">
.user-img {
  width: 100%;
  height: 100%;
}
.blank {
  //position: absolute;
  //top: 0;
  //left: 0;
  //width: 100%;
  //height: 100%;
  background-image: url('~@/assets/images/user_profile.svg');
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  // 필요시 아래는 등록하는 부모 컴포넌트에서 설정한다.
  //z-index: 1;
  //background-color: #000;
  //background-size: auto 30%;
}
</style>